// Configurable constants for offers selection UI
// Move these values here so they can be modified without changing component logic.
export const OFFER_CONFIG = {
  // Minimum allowed advance amount when decrementing offers
  MIN_ADVANCE_AMOUNT: 2000,
  // Step (increment/decrement) amount
  AMOUNT_STEP: 500
};
